import React, { Component } from "react";
import arrPrev from '../../images/Ellipse6.png';
import nextArrow from '../../images/Ellipse6.png';
import * as Constanti from '../../Utils/constants.js';
import '../../style/categoriauno.css';
import '../../style/generic.css';
import Slider from "react-slick";
import axios from "axios";
import { Link } from "react-router-dom";
import CardOne from "../cards/cardOne.js";
import { motion } from "framer-motion";

class Category1 extends Component{
  constructor(props){
    
    super(props);
    this.state = {
      video: [],
       isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false
      }
      this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
}

next() {
  this.slider.slickNext();
}
previous() {
  this.slider.slickPrev();
}


  componentDidMount() {
    var apiBaseUrl = Constanti.url_Backend+"getVideoByCategory";
    var payload= {
      "id_categoria": this.props.category,
      "limit":this.props.limit
    }
    
      var self = this;
      axios.post(apiBaseUrl, payload).then(function (response) {
      if (response.data.data != null){
         var location = response.data.data;
         self.setState({ video : location })
      }else{
        console.log("non ci sono video per questo id");
      }
      self.setState({load:false});
    })
    .catch(function (error) {
    console.log(error);
    self.setState({load:false});
    });

  }

  render(){
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      centerMode: false,
      centerPadding: '60px',
      slidesToShow:1, 
      slidesToScroll: 1,
      variableWidth: true,
    };
    const { video,isMobile } = this.state;
    const listaVideo = video.slice(this.props.slice);
    return (
      <section className="categorysection">
    <div className="container">
<div className="slider-wrapper">
<div className="slider-title-wrapper margin-bottom-24">
<h2 className="h2">In evidenza</h2>
<Link to={'/categoria/'+this.props.category}>
      <span className="button secondary small w-button heigth-32">Vedi tutti</span>
      </Link>
</div>
{!isMobile && 
<div className="grid-evidenza">
 {listaVideo != null && listaVideo.slice(0, 3).map((el, index) => (
             <motion.div
      key={el.id}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{
        duration: 0.9,
        delay: index * 0.2,
        ease: "easeOut"
      }}
     // importante per non rompere lo slider
    >
                    <div className="paddingRight5" key={el.id}>
          <Link to={'/video/'+el.id}>
          <CardOne thumbnail={el.thumbnail} title={el.title} data={el.created_at}></CardOne>
          </Link>
              </div>
              </motion.div>
      
      
          ))}
      </div>
}
{isMobile && 

 <div className="container-home slider-container" >
    <Slider ref={c => (this.slider = c)} {...settings}>
    {video != null && video?.map(el => (
      <div className="card-small" key={el.id} >
      <Link to={'/video/'+el.id}>
    <CardOne thumbnail={el.thumbnail} title={el.title} data={el.created_at}></CardOne>
    </Link>
    </div>))}
   </Slider>
    </div>
}
</div>
</div>
</section>)
  }
}
export default Category1; 





